import { useGoogleLogin } from '@react-oauth/google';
import { useState } from 'react';
import { Button, Card, Grid, Text } from '@mantine/core';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router';
import useFetch from '../../helpers/useFetch';
import { setGoogleAccount as setGoogleAccountRedux } from '../../store/googleSlice';
import ErrorMessage from '../ErrorMessage';

const GoogleConnectButton = () => {
  const fetch = useFetch();
  const dispatch = useDispatch();

  const scope =
    'openid https://www.googleapis.com/auth/userinfo.email https://www.googleapis.com/auth/userinfo.profile https://www.googleapis.com/auth/adwords https://www.googleapis.com/auth/content  https://www.googleapis.com/auth/analytics.readonly https://www.googleapis.com/auth/analytics.edit';

  const [error, setError] = useState();
  const { accountId, domainId } = useParams();
  const currentGoogleAccount = useSelector((state) => state.google.account);
  const buttonName = currentGoogleAccount?.refreshTokenRevoked
    ? 'Reconnect Google to Releva'
    : 'Connect Google to Releva';

  const googleLogin = useGoogleLogin({
    onSuccess: (tokenResponse) => {
      fetch(`/api/admin/accounts/${accountId}/domains/${domainId}/google/account`, {
        method: 'POST',
        body: JSON.stringify({ code: tokenResponse.code }),
      })
        .then(({ googleAccount }) => {
          dispatch(setGoogleAccountRedux(googleAccount));
        })
        .catch(setError);
    },
    onError: (error) => {
      console.log(error);
      setError({ message: 'Google login failed, please try again later or contact support!' });
    },
    flow: 'auth-code',
    scope,
  });

  return (
    <Card withBorder>
      <Card.Section inheritPadding py="sm">
        <Grid>
          <Grid.Col span={{ base: 12, sm: 4 }}>
            <Text size="sm" fw={500}>Connection</Text>
          </Grid.Col>
          <Grid.Col span={{ base: 12, sm: 2 }}>
            <Button variant="filled" onClick={googleLogin}>
              {buttonName}
            </Button>
            {currentGoogleAccount?.refreshTokenRevoked && (
              <Text size="sm" c="yellow">
                Attention: Your session has expired, and your refresh token has been revoked. Please reconnect.
              </Text>
            )}

            <ErrorMessage message={error?.message} />
          </Grid.Col>
        </Grid>
      </Card.Section>
    </Card>
  );
};

export default GoogleConnectButton;
